<app-auth-form
	[isRegister]="mode === 'expired' ? 6 : 5"
	[initialEmail]="initialEmail"
	[loading]="loading"
	[showSuccessState]="resendSent"
	[requirePrivacy]="requirePrivacy"
	(formSubmit)="onSubmit($event)"
></app-auth-form>
